import React from 'react';

const ScrollTop = React.createClass({
    propTypes: {},
    componentDidMount: function() {
        this.elevator = new Elevator({
            duration: 1500
        });
    },
    _handleClick: function () {
        this.elevator.elevate();
    },
    render: function() {
        return (
            <span className="scroll-top" onClick={this._handleClick}>
                <div className="scroll-top-arrow" />
                <span>Nach oben</span>
            </span>
        );
    }
});

export default ScrollTop;



// WEBPACK FOOTER //
// ./src/js/components/ScrollTop.js